import packageJson from "../../../package.json";
import { AuthClient } from "@ts-digital/agyo-authclient-nodejs";
import { APP_NAME } from "../../config";

const appVersion = packageJson.version;
const authClient = new AuthClient(
  APP_NAME, appVersion, "http://localhost:8080", 10000
);

export function getUID(jwtToken) {
  return authClient.getUserId(jwtToken);
}

export function getName(jwtToken) {
  return authClient.getName(jwtToken);
}

export function getSubject(jwtToken) {
  return authClient.getSubject(jwtToken);
}
